
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {getOnecheckoutsdb } from '../../api/checkoutsdb.api'

import './checkoutinfo.scss';






const Pcheckoutinfo = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_68e5881ba5fe5912e60023c5, setLoftyEndpoint_68e5881ba5fe5912e60023c5] = useState({});
	

useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_68e5881ba5fe5912e60023c5 = await getOnecheckoutsdb({ _id: match.params._id, token: loftytoken || 'asdsa' });
			setLoftyEndpoint_68e5881ba5fe5912e60023c5(loftyres_68e5881ba5fe5912e60023c5.data);
		}
		loftyHandleData();
	}, []);



  
  
  
  

  
  return (
    <div id="id68e6f8a38e5aed52dc7f1e0a" >

      <div id="iw4j" className="">
      
      <div id="iwv3ah" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggu1zyt.png"
        alt="undefined"
      />
      
      <div className="" id="iaew8b">
        <>PETRUS GEMS</>
      </div>
      
      </div>
      
      <div id="i2km6v" className="">
      
        <a
          target=""
          className=""
          id="ii0ajg"
          href="#"
        >
          
    <div id="ibi4fk" className="">
    <>+50488951552</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <div id="i7kgb7" className="">
      
      <div id="iowj1k" className="">
      
      <a
        target=""
        className="link "
        id="il8xfg"
        href="/"
        type="button"
      >
        
    <div id="ihswfv" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="iuicrj"
        href="/productos"
        type="button"
      >
        
    <div id="ih9i7g" className="">
    <>PRODUCTOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="ib4wzs"
        href="/certificaciones"
        type="button"
      >
        
    <div id="ie4p6q" className="">
    <>CERTIFICACIONES</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="itj7od"
        href="/contacto"
        type="button"
      >
        
    <div id="i6b0kg" className="">
    <>CONTACTO</>
    </div>
    
      </a>
      
      </div>
      
      <div id="ib86j7" className="">
      
        <a
          target=""
          className=""
          id="if4a4b"
          href="/carritocompras"
        >
          
      <img
        className=""
        id="ioivtk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjoujuz.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i3dh" className="">
      
      <div id="ir0eig" className="">
      
      <div id="ijjx6g" className="">
      
      <div id="ieasx9" className="">
      
      <div className="" id="icuiwb">
        <>Resumen de Compra</>
      </div>
      
      </div>
      
      </div>
      
        <div id="ie5q2l" className="">
        
      <div id="iy5oih" className="">
      
      <div id="i2sn9j" className="">
      
      <div id="ix39ka" className="">
      
      <div className="" id="ic5hru">
        <>Productos</>
      </div>
      
      </div>
      
        <div className="" id="iqghs2">
          
          {
            loftyendpoint_68e5881ba5fe5912e60023c5?.productstocheckout?.map((item_cart_loftyendpoint_68e5881ba5fe5912e60023c5) => (
              <div className="" id="i0d49g">
                
        <div className="" id="ikbb7k">
          
              <div className="" id="">
                {parseFloat(item_cart_loftyendpoint_68e5881ba5fe5912e60023c5?.productdesc).toLocaleString('en-US', {minimumFractionDigits: 2})}
              </div>
              
        </div>
        
        <div className="" id="i7kaej">
          
              <div className="" id="">
                {parseFloat(item_cart_loftyendpoint_68e5881ba5fe5912e60023c5?.typeofproduct).toLocaleString('en-US', {minimumFractionDigits: 2})}
              </div>
              
        </div>
        
        <div className="" id="imjmzv">
          
            <div className="" id="">
              {item_cart_loftyendpoint_68e5881ba5fe5912e60023c5?.loftyOriginalName}
            </div>
            
        </div>
        
        <div className="" id="ip6j9z">
          
            <div className="" id="">
              {item_cart_loftyendpoint_68e5881ba5fe5912e60023c5?.loftyFileName}
            </div>
            
        </div>
        
        <div className="" id="i7472q">
          
            <div className="" id="">
              {item_cart_loftyendpoint_68e5881ba5fe5912e60023c5?.loftyUrl}
            </div>
            
        </div>
        
        <img
          className=""
          id="i8yda2"
          alt=""
          src={loftyendpoint_68e5881ba5fe5912e60023c5.loftyUrl}
        />
        
        <div className="" id="i5v75w">
          
            <div className="" id="">
              {item_cart_loftyendpoint_68e5881ba5fe5912e60023c5?.productname}
            </div>
            
        </div>
        
        <div className="" id="isvssv">
          
              <div className="" id="">
                {parseFloat(item_cart_loftyendpoint_68e5881ba5fe5912e60023c5?.productprice).toLocaleString('en-US', {minimumFractionDigits: 2})}
              </div>
              
        </div>
        
      <div id="iayimj" className="">
      <>
            Cantidad: 
          </>
      </div>
      
              </div>
            ))
          }
        
        </div>
        
      </div>
      
      <div id="it2qkm" className="">
      
      <div id="i2p876" className="">
      
      <div className="" id="ivqq6m">
        <>Dirección de Envio</>
      </div>
      
      </div>
      
      <div id="ib999k" className="">
      
        <div className="" id="iod7ww">
          
          <div className="" id="">
            {loftyendpoint_68e5881ba5fe5912e60023c5?.nameorder}
          </div>
          
        </div>
        
        <div className="" id="ict5lx">
          
          <div className="" id="">
            {loftyendpoint_68e5881ba5fe5912e60023c5?.phonenumber}
          </div>
          
        </div>
        
        <div className="" id="iruwzz">
          
          <div className="" id="">
            {loftyendpoint_68e5881ba5fe5912e60023c5?.fulladdress}
          </div>
          
        </div>
        
        <div className="" id="i5mcfa">
          
          <div className="" id="">
            {loftyendpoint_68e5881ba5fe5912e60023c5?.city}
          </div>
          
        </div>
        
      </div>
      
      </div>
      
      </div>
      
        </div>
        
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        <>Petrus Gems</>
      </div>
      
      <div className="" id="iygu8i">
        <>Elaboración de joyas de forma artesanal por mano de mujeres en nuestras comunidades</>
      </div>
      
      <div id="ix6pbo" className="">
      
        <a
          target=""
          className=""
          id="ibwuje"
          href="https://www.facebook.com/gemspetrus.hn"
        >
          
      <img
        className=""
        id="iy1qpk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiadxwc.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="iqvgxw"
          href="https://www.instagram.com/gemspetrus/"
        >
          
      <img
        className=""
        id="i26xh9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiafdkq.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Enlaces Rápidos</>
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/productos"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Productos</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/certificados"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>Certificados</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/contacto"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div id="iincid" className="">
      
      <span className="material-icons " id="iwlmju">
        
      <span className="material-icons " id="iz5z0g">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="i78qcc">
        <>+504 8895-1552</>
      </div>
      
      </div>
      
      <div id="idmnrv" className="">
      
      <span className="material-icons " id="i7tn5m">
        
      <span className="material-icons " id="isg8ci">
        
      <span className="material-icons " id="iuenok">
        <>mail</>
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="il1rnw">
        <>handalcarl13@gmail.com</>
      </div>
      
      </div>
      
      <div id="i2jt24" className="">
      
      <span className="material-icons " id="il9zag">
        
      <span className="material-icons " id="iom84k">
        
      <span className="material-icons " id="i1y0v4">
        
      <span className="material-icons " id="iwl57t">
        <>my_location</>
      </span>
      
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="i1at63">
        <>ubicacion</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcheckoutinfo);
  